module.exports = __webpack_public_path__ + "static/img/home1-bg5-content.793b0be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home1-bg5-content.png
// module id = Qn3j
// module chunks = 0